import { useEffect, useMemo, useState } from 'react'
import './AppContent.scss'
import { useTranslation } from 'react-i18next'
import { Button, Dropdown, Drawer, Tooltip, Switch } from 'antd'
import { AppstoreOutlined, BulbOutlined } from '@ant-design/icons'
import { PowerSettingsNew } from '@material-ui/icons'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import i18n from 'i18next'
import {
    Gd6DLogo,
    Gd6DLogoDashboard,
    Gd6DLogoManagementMob,
    Gd6DLogoManagementAcc,
    Gd6DLogoOpeAccLogo,
} from '../SvgComponent'
import logoE3D from '../../static/logo-e3d-blc.png'
import favicon from '../../static/favicon.ico'
import logoAdmin from '../../static/logo_admin.png'
import imageTablette from '../../static/ImageTablette.png'
import imageMA from '../../static/MA.png'
import imageDashboard from '../../static/Dashboard.png'
import { formatText } from '../../helpers'
import ActionLoading from '../ActionLoading/ActionLoading'
import URLAPPGD6D from '../../variables/URLAPPGD6D'
import RenderFaq from './Faq/RenderFaq'

const AppContent = ({ user, logOut, darkMode, onToggleDarkMode }) => {
    const token = useMemo(() => user.token, [user.token])
    const infos = useMemo(() => user.infos, [user.infos])
    const access = useMemo(() => user.access, [user.access])
    const alert = useMemo(() => user.alert, [user.alert])

    const [faqOpen, setFaqOpen] = useState(false)

    const { t } = useTranslation()

    const { trackEvent, trackPageView, pushInstruction } = useMatomo()

    // Identifie l'utilisateur dans Matomo dès qu'il est connu
    useEffect(() => {
        if (infos?.member_id) {
            pushInstruction('setUserId', String(infos.member_id))
        }
    }, [infos?.member_id])

    // Dimension personnalisée 1 : Utilisateur (nom complet)
    useEffect(() => {
        const fullName = `${infos?.first_name || ''} ${infos?.last_name || ''}`.trim()
        if (fullName) pushInstruction('setCustomDimension', 1, fullName)
    }, [infos?.first_name, infos?.last_name])

    // Dimension personnalisée 2 : Client_name
    useEffect(() => {
        if (infos?.client_name) pushInstruction('setCustomDimension', 2, infos.client_name)
    }, [infos?.client_name])

    // Pageview de la page d'accueil
    useEffect(() => {
        trackPageView({ documentTitle: 'accueil' })
    }, [])

    const initials = [infos?.first_name?.[0], infos?.last_name?.[0]]
        .filter(Boolean).join('').toUpperCase()

    const today = new Date().toLocaleDateString('fr-FR', {
        weekday: 'long', day: 'numeric', month: 'long'
    })

    const openWithToken = (url, appKey) => {
        if (!url) return
        if (appKey) trackEvent({ category: 'navigation', action: 'click-app', name: appKey })
        const form = document.createElement('form')
        form.setAttribute('action', url)
        form.setAttribute('method', 'POST')
        form.setAttribute('target', '_blank')
        const inputToken = document.createElement('input')
        inputToken.setAttribute('type', 'hidden')
        inputToken.setAttribute('name', 'token')
        inputToken.setAttribute('value', token)
        const inputLang = document.createElement('input')
        inputLang.setAttribute('type', 'hidden')
        inputLang.setAttribute('name', 'language')
        inputLang.setAttribute('value', i18n.language)
        form.appendChild(inputToken)
        form.appendChild(inputLang)
        document.body.appendChild(form)
        form.style.display = 'none'
        form.submit()
        document.body.removeChild(form)
    }

    const apps = [
        { key: 'admin',     label: 'Administration',              Logo: null,                  url: URLAPPGD6D.admin,     enabled: !!access?.administration },
        { key: 'dashboard', label: 'Dashboard',                   Logo: Gd6DLogoDashboard,     url: URLAPPGD6D.dashboard, enabled: access?.supervision_dashboard },
        { key: 'manaMob',   label: 'Management Mobilisation',     Logo: Gd6DLogoManagementMob, url: URLAPPGD6D.manaMob,   enabled: access?.management_mobilisation },
        { key: 'manaAcc',   label: 'Management Accompagnement',   Logo: Gd6DLogoManagementAcc, url: URLAPPGD6D.manaAcc,   enabled: access?.management_accompagnement },
        { key: 'opeAcc',    label: 'Animation Téléphonique',      Logo: Gd6DLogoOpeAccLogo,    url: URLAPPGD6D.opeAcc,    enabled: access?.operation_accompagnement },
    ]

    const appSwitcherMenu = {
        items: [
            {
                key: 'ecosystem',
                icon: <Gd6DLogo width={18} height={18} />,
                label: <span onClick={() => openWithToken(URLAPPGD6D.ecosystem, 'ecosystem')}><strong>Ecosystème GD6D</strong></span>,
            },
            ...apps.map(({ key, label, url, enabled }) => ({
                key,
                icon: <Gd6DLogo width={18} height={18} />,
                label: enabled
                    ? <span onClick={() => openWithToken(url, key)}>{label}</span>
                    : <span>{label}</span>,
                disabled: !enabled,
            })),
        ]
    }

    return (
        <div className='app-content'>
            <Drawer
                title={`Bonjour ${infos?.first_name || ''} ${infos?.last_name || ''}, nous sommes là pour vous aider !`}
                placement="left"
                onClose={() => setFaqOpen(false)}
                open={faqOpen}
                width="50%"
            >
                <RenderFaq />
            </Drawer>
            <header className='app-content__headbar'>
                <div className='headbar-wrap'>
                    <div className='headbar-left'>
                        <Dropdown menu={appSwitcherMenu} trigger={['click']} placement="bottomLeft">
                            <Button type="text" icon={<AppstoreOutlined style={{ fontSize: 20 }} />} className="headbar-app-switcher" />
                        </Dropdown>
                        <span className='headbar-app-name'>Ecosystème GD6D</span>
                        <img src={favicon} alt="" className="headbar-favicon" />
                    </div>
                    <div className='headbar-right'>
                        {infos?.client_name && <span className='headbar-client-name'>{infos.client_name}</span>}
                        <div className='headbar-circle' onClick={() => { trackEvent({ category: 'faq', action: 'open' }); setFaqOpen(true) }} title="Aide / FAQ">?</div>
                        <Dropdown
                            trigger={['click']}
                            placement="bottomRight"
                            dropdownRender={() => (
                                <div className="user-dropdown">
                                    <div className="user-dropdown-header">
                                        <div className="headbar-circle headbar-circle--user headbar-circle--large">{initials}</div>
                                        <div className="user-dropdown-info">
                                            <div className="user-dropdown-name">
                                                {`${infos?.first_name || ''} ${infos?.last_name || ''}`.trim()}
                                            </div>
                                            <div className="user-dropdown-email">{infos?.mail_address || ''}</div>
                                            {infos?.team_name && <div className="user-dropdown-team">{infos.team_name}</div>}
                                        </div>
                                    </div>
                                    <div className="user-dropdown-divider" />
                                    <div className="user-dropdown-darkmode">
                                        <BulbOutlined style={{ fontSize: 15 }} />
                                        <span className="user-dropdown-darkmode__label">{formatText(t('mode_sombre'))}</span>
                                        <Switch size="small" checked={darkMode} onChange={val => { trackEvent({ category: 'ui', action: 'dark-mode', name: val ? 'on' : 'off' }); onToggleDarkMode(val) }} />
                                    </div>
                                    <div className="user-dropdown-divider" />
                                    <div className="user-dropdown-disconnect" onClick={() => { trackEvent({ category: 'navigation', action: 'click', name: 'deconnexion' }); pushInstruction('resetUserId'); logOut() }}>
                                        <PowerSettingsNew style={{ fontSize: 16 }} />
                                        <span>{formatText(t('deconnexion'))}</span>
                                    </div>
                                </div>
                            )}
                        >
                            <div className='headbar-circle headbar-circle--user'>{initials}</div>
                        </Dropdown>
                    </div>
                </div>
            </header>
            <div className='headbar-gradient' />
            {alert && <ActionLoading alert={alert} />}
            <div className='app-content__body'>
                <div className='home-panel'>
                    <div className='home-panel__top'>
                        <div className='home-panel__left'>
                            <p className='home-panel__date'>{today}</p>
                            <h1 className='home-panel__greeting'>Bonjour {infos?.first_name},</h1>
                            <p className='home-panel__intro'>
                                Pilotez vos actions de changement de comportement et mesurez les impacts avec la suite GD6D&nbsp;!
                            </p>
                            <ul className='home-panel__features'>
                                <li>Mobilisation en porte-à-porte</li>
                                <li>Accompagnement téléphonique</li>
                                <li>Pilotage des équipes</li>
                                <li>Suivi en temps réel</li>
                            </ul>
                        </div>
                        <div className='home-panel__right'>
                            <img src={imageTablette} alt='Tablette' className='home-panel__tablet-img' />
                            <div className='home-panel__screens'>
                                <img src={imageDashboard} alt='Dashboard' className='home-panel__screen home-panel__screen--ma' />
                                <img src={imageMA} alt='Management Accompagnement' className='home-panel__screen home-panel__screen--dashboard' />
                            </div>
                        </div>
                    </div>
                    <div className='home-panel__bottom'>
                        <h2 className='home-panel__apps-title'>Vos applications</h2>
                        <div className='home-panel__apps'>
                            {apps.map(({ key, label, Logo, url, enabled }) => (
                                <Tooltip key={key} title={label} placement="bottom">
                                    <div
                                        className={`app-card${enabled ? ' app-card--enabled' : ' app-card--disabled'}`}
                                        onClick={() => enabled && openWithToken(url, key)}
                                    >
                                        {Logo
                                            ? <Logo width={154} height={51} isDisabled={!enabled} />
                                            : <img src={logoAdmin} alt='Administration' className='app-card__img-logo' />
                                        }
                                    </div>
                                </Tooltip>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className='app-content__footer'>
<span>{formatText(t('un_dispositif'))}</span>
                <a href='http://www.e3d-environnement.com/' target='blank'><img src={logoE3D} alt='Logo E3D-Environnement' /></a>
            </div>
        </div>
    )
}

export default AppContent
